import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { UnlockCustomModelPopup } from './UnlockCustomModelPopup';

const UNLOCK_CUSTOM_MODEL_POPUP = Symbol('UNLOCK_CUSTOM_MODEL_POPUP');

export const useUnlockCustomModelPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(UNLOCK_CUSTOM_MODEL_POPUP, UnlockCustomModelPopup);
  });

  return useCallback(() => {
    popups.openPopup(UNLOCK_CUSTOM_MODEL_POPUP, {
      onClose: () => {
        popups.closePopup(UNLOCK_CUSTOM_MODEL_POPUP);
      },
    });
  }, [popups]);
};
